export const profileScoreFormatter = (profileScore) => {
  let formattedObject = {
    EONScore: profileScore.EONScoreAuto,
    insuranceScore: profileScore.insuranceScoreAuto,
    supplierScore: profileScore.supplierScoreAuto,
    bonusScore: profileScore.bonusScoreAuto,
    energyAndConsumptionScore: profileScore.energyAndConsumptionScoreAuto,
    trainingScore: profileScore.trainingScore,
    certifiedScore: profileScore.certifiedScoreAuto,
    profileId: profileScore.profileId,
    type: profileScore.type,
    EonScoreIsAuto: profileScore.EonScoreIsAuto,
    insuranceScoreIsAuto: profileScore.insuranceScoreIsAuto,
    supplierScoreIsAuto: profileScore.supplierScoreIsAuto,
    trainingCourses: profileScore.trainingCourses || [],
    trainingScore: profileScore.trainingScore || 0,
  };

  if (profileScore.EonScoreIsAuto === false) {
    formattedObject = {
      ...formattedObject,
      EONScore: profileScore.EONScoreManual,
    };
  }

  if (profileScore.insuranceScoreIsAuto === false) {
    formattedObject = {
      ...formattedObject,
      insuranceScore: profileScore.insuranceScoreManual,
    };
  }

  if (profileScore.supplierScoreIsAuto === false) {
    formattedObject = {
      ...formattedObject,
      supplierScore: profileScore.supplierScoreManual,
    };
  }

  return formattedObject;
};
